<template>
  <div class="content">
    <NavBar :navtitle="navtitle" :navBlock="navBlock"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item class="searchItem">
              <el-select v-model="listMenuForm.memberStatus">
                <el-option label="昵稱" value="0"></el-option>
                <el-option label="賬號" value="1"></el-option>
                <el-option label="關鍵詞" value="2"></el-option>
              </el-select>
              <el-input
                v-model="listMenuForm.searchKey"
                placeholder="在左側選擇搜索類別"
              ></el-input>
            </el-form-item>
            <el-form-item label="精選類型" style="margin-left: 200px;">
              <el-select v-model="listMenuForm.choice">
                <el-option label="全部" value=""></el-option>
                <el-option label="精選" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="回信詳情" class="searchItem ">
              <el-select v-model="listMenuForm.reply" placeholder="全部">
                <el-option label="全部" value=""></el-option>
                <el-option label="已回信" value="1"></el-option>
                <el-option label="未回信" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="發信時間"
              class="searchItem hidden-lg-and-down"
            >
              <el-date-picker
                v-model="listMenuForm.time"
                style="width: 400px;"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm hidden-xl-only"
          >
            <el-form-item label="發信時間" class="searchItem ">
              <el-date-picker
                v-model="listMenuForm.time"
                type="datetimerange"
                style="width: 400px;"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="btn" @click="search">查詢</div>
        <div class="btn borderBtn" @click="reset">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="userInfoList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'createTime'">
                {{ $getTime(scope.row[item.prop]) }}
              </div>
              <div v-else-if="item.prop === 'content'">
                <el-button @click="showContent(scope.row)" type="text"
                  >查看詳情</el-button
                >
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- v-if="scope.row.authorizationCode != '審核不通過'"  -->
              <el-button @click="toSet(scope.row)" type="text">{{
                scope.row.choice == 1 ? "取消精選" : "選爲精選"
              }}</el-button>
              <el-button @click="toReply(scope.row)" type="text">{{
                scope.row.replyId ? "已回信" : "回信"
              }}</el-button>
              <el-button
                v-throttle="{
                  fn: () => {
                    toDeled(scope.row);
                  },
                  time: 2000
                }"
                type="text"
                >刪除</el-button
              >
              <!-- <el-button v-else type="text" style="color:#eee;">查看詳情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
    <el-dialog
      :visible.sync="showMoadl"
      title="回信"
      width="500"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="letterValue" @change="handchangeVip">
        <el-radio :label="1">文字回信</el-radio>
        <el-radio :label="2">視頻回信</el-radio>
      </el-radio-group>
      <div style="margin-top: 30px;">
        <div v-if="letterValue == 1">
          <textarea
            class="chart_input"
            rows="3"
            v-model="replyContent"
            placeholder="请输入回信"
          ></textarea>
        </div>
        <div v-else>
          <el-form>
            <el-form-item label="上傳主圖 ：" >
              <el-upload
                action=""
                :http-request="uploadRequest"
                :with-credentials="true"
                :headers="{ Authorization: this.$cookie.get('auth') }"
                :on-error="$errorImage"
                :on-exceed="$handleExceed.bind(this, 1)"
                :on-remove="titleHandleRemove"
                :file-list="titlePictureUrl"
                :on-progress="uploadImgProcess"
                :before-upload="beforePicUpload"
                :limit="1"
                accept=".jpg,.jpeg,.png"
                :multiple="false"
                name="titlePage"
                list-type="picture-card"
              >
                <el-button v-if="!imgFlag" size="small" type="primary"
                  >選擇圖片</el-button
                >
                <div slot="tip" class="el-upload__tip">支持jpg/png/格式</div>
                <el-progress
                  v-if="imgFlag"
                  type="circle"
                  :percentage="imgUploadPercent"
                  style="margin-top:10px;"
                ></el-progress>
              </el-upload>
            </el-form-item>
            <el-form-item label="上傳影片 ：">
              <div style="display: flex;align-items: flex-end;">
                <video
                  width="50%"
                  v-if="VideoUrl.length == 1"
                  class="avatar"
                  :src="VideoUrl[0].url"
                  controls="controls"
                >
                  您的浏览器不支持视频播放
                </video>
                <div
                  @click="handleVideoRemove()"
                  style="cursor: pointer;font-size: 16;color: blueviolet;margin-left: 10px;"
                  v-if="VideoUrl.length == 1"
                >
                  刪除
                </div>
              </div>
             <el-upload
                  action=""
                  :http-request="uploadRequest"
                  :with-credentials="true"
                  :headers="{ Authorization: this.$cookie.get('auth') }"
                  :on-error="errorVideo"
                  :on-exceed="handleVideoExceed"
                  :on-remove="handleVideoRemove"
                  :on-progress="uploadVideoProcess"
                  :file-list="VideoUrl"
                  :show-file-list="false"
                  :before-upload="beforeVideoUpload"
                  :limit="1"
                  accept=".mp4"
                  :multiple="false"
                  name="vedio"
                  list-type="picture-card"
                >
                  <el-button v-if="!videoFlag" size="small" type="primary"
                    >選擇視頻</el-button
                  >
                      <div slot="tip" class="el-upload__tip">支持mp4格式</div>
                  <el-progress
                    v-if="videoFlag"
                    type="circle"
                    :percentage="videoUploadPercent"
                    style="margin-top:10px;"
                  ></el-progress>
                </el-upload>
              <!-- <div>支持mp4格式</div> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px;">
        <el-button type="primary" @click="getSubmit">
          回信
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="fanMoadl"
      title="寄信内容"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <textarea
          class="chart_input"
          disabled
          style="border: none;"
          rows="3"
          v-model="letter"
        ></textarea>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";
import fileUtils from "@/utils/fileUtils.js";
import Mint from "mint-ui"; //引入mint-ui
export default {
  data() {
    return {
      navBlock: "粉絲來信",
      navtitle: "信件列表",
      userInfoList: [],
      listMenuForm: {
        startTime: "",
        endTime: "",
        choice: "",
        reply: "",
        username: "",
        nickname: "",
        keyword: "",
        memberStatus: "1",
        time: []
      },
      letterValue: 1,
      img: "",
      showMoadl: false,
      letter: "",
      username: "",
      replyContent: "",
      fanMoadl: false,
      imgFlag: false,
      id: "",
      userInfoTable: [
        {
          prop: "username",
          label: "賬號"
        },
        {
          prop: "nickname",
          label: "昵稱",
          width: ""
        },
        {
          prop: "content",
          label: "寄信内容"
        },
        {
          prop: "createTime",
          label: "發信時間"
        }
      ],
      currentPage: 1,
      total: 10,
      dialogVisible: false,
      has_next: false,
      mainPictureUrl: [], // 主图
      titlePictureUrl: [], // 封面
      VideoUrl: [], // 视频类型的video
      audioFile: [], // 音频文件list
      videoFlag: false
    };
  },
  created() {
    let _this = this;
    _this.getUserInfoList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$get(
          `/request/letter/list?page=${_this.currentPage}&size=10&nickname=${_this.listMenuForm.nickname}&username=${_this.listMenuForm.username}&choice=${_this.listMenuForm.choice}&startTime=${_this.listMenuForm.startTime}&reply=${_this.listMenuForm.reply}&endTime=${_this.listMenuForm.endTime}&keyword=${_this.listMenuForm.keyword}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          // _this.listMenuForm.username = '';
          // _this.listMenuForm.nickname = '';
          // _this.listMenuForm.keyword = '';
          if (res.code === "00000") {
            _this.total = res.data.total;
            _this.has_next = res.data.has_next;
            _this.userInfoList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },
    //回信
    getSubmit: throttle(
      function() {
        return true;
      },
      function() {
        this.$message.closeAll();
        if (this.letterValue == 1) {
          if (!this.replyContent) {
            this.$message({
              message: "請輸入回信內容",
              type: "warning"
            });
            return;
          }
        } else {
          if (this.titlePictureUrl.length == 0) {
            this.$message({
              message: "請上傳主圖",
              type: "warning"
            });
            return;
          }
          if (this.VideoUrl.length == 0) {
            this.$message({
              message: "請上傳影片",
              type: "warning"
            });
            return;
          }
        }
        const param = {
          replyId: this.id,
          content: this.replyContent,
          videoUrl: this.VideoUrl.length > 0 ? this.VideoUrl[0].url : "",
          videoImg:
            this.titlePictureUrl.length > 0 ? this.titlePictureUrl[0].url : ""
        };
        let _this = this;
        _this
          .$confirm(
            `是否給${_this.username}回信,回信后會推送給該用戶和所有用戶，且内容將會顯示給所有用戶?`,
            "提示信息",
            {
              confirmButtonText: "確定",
              cancelButtonText: "取消",
              center: true,
              closeOnClickModal: false
            }
          )
          .then(() => {
            // 确认删除的回调
            this.$post(
              `/request/letter/reply`,
              param,
              _this.$GLOBAL.jsonConfig
            ).then(res => {
              _this.dialogVisible = true;
              this.titlePictureUrl = [];
              this.VideoUrl = [];
              this.videoFlag = false;
              this.imgFlag = false;
              if (res.code === "00000") {
                _this.dialogVisible = false;
                this.$message({
                  message: "回信成功",
                  type: "success"
                });
                this.showMoadl = false;
                this.replyContent = "";
                _this.VideoUrl = [];
                _this.titlePictureUrl = [];
                _this.getUserInfoList();
              } else {
                this.showMoadl = false;
                this.replyContent = "";
                _this.dialogVisible = false;
                _this.$propMessage(res.message, "error");
              }
            });
          });
      },
      2000
    ),

    // 查询
    search() {
      if (this.listMenuForm.memberStatus == '' && this.listMenuForm.searchKey) {
        this.$propMessage('請選擇搜索類別', 'error');
        return false;
      }
      if (this.listMenuForm.memberStatus == "1") {
        this.listMenuForm.username = this.listMenuForm.searchKey ? this.listMenuForm.searchKey : '';
      } else if (this.listMenuForm.memberStatus === "0") {
        this.listMenuForm.nickname = this.listMenuForm.searchKey ? this.listMenuForm.searchKey : '';
      } else if (this.listMenuForm.memberStatus === "2") {
        this.listMenuForm.keyword = this.listMenuForm.searchKey ? this.listMenuForm.searchKey : '';
      }
      if (this.listMenuForm.time.length > 0) {
        this.listMenuForm.startTime = this.$getTime(this.listMenuForm.time[0]);
        this.listMenuForm.endTime = this.$getTime(this.listMenuForm.time[1]);
      }

      let _this = this;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        startTime: "",
        endTime: "",
        reply: "",
        choice: "",
        username: "",
        nickname: "",
        keyword: "",
        memberStatus: "",
        time: []
      };
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    //查看回信
    showContent(e) {
      this.letter = e.content;
      this.fanMoadl = true;
      this.img = e.img;
    },
    // 封面图移除图片的回调函数
    titleHandleRemove(file) {
      this.imgFlag = false;
      this.$deleteUidItem(file.uid, this.titlePictureUrl);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
      return false;
    },
    // 移除音频
    handleAudioRemove(file) {
      this.$deleteUidItem(file.uid, this.audioFile);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
      return false;
    },
    // 上传视频
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        let fileWay = "";
        if (
          extensionName === ".mp4" ||
          extensionName === ".MP4" ||
          extensionName === ".Mp4" ||
          extensionName === ".mP4"
        ) {
          fileWay = "resource/video/";
        } else if (extensionName === ".mp3") {
          fileWay = "resource/audio/";
        } else {
          fileWay = "resource/image/";
        }
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              progress: function(p) {
                if (
                  extensionName === ".mp4" ||
                  extensionName === ".MP4" ||
                  extensionName === ".Mp4" ||
                  extensionName === ".mP4"
                ) {
                  if (p > 0) {
                    self.videoFlag = true;
                  } else if ((p = 1)) {
                    self.videoFlag = false;
                  }
                  self.videoUploadPercent = Math.floor(p * 100);
                } else {
                  if (p > 0) {
                    self.imgFlag = true;
                  } else if ((p = 1)) {
                    self.imgFlag = false;
                  }
                  self.imgUploadPercent = Math.floor(p * 100);
                }
              },
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  if (option.filename === "vedio") {
                    self.VideoUrl.push({
                      name: "video.mp4",
                      url: self.$GLOBAL.picFileUrl + val.name
                    });
                    // cdn预热
                    // self.$cdnFun(self.VideoUrl[0].url).then(res=>{
                    //   this.pushTaskId=res.data.pushTaskId
                    // })
                    self.$convertVideo(val.name).then(res => {});
                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                  } else if (option.filename === "titlePage") {
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                    self.titlePictureUrl.push({
                      name: "image.jpeg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    });
                    //cdn预热
                    self.$cdnFun(self.titlePictureUrl[0].url).then(res => {});
                  } else if (option.filename === "mainPic") {
                    self.mainPictureUrl.push({
                      name: "image.jpeg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    }); // 展示图片
                    //cdn预热
                    self.$cdnFun(self.mainPictureUrl[0].url).then(res => {});
                    if (this.mainPictureUrl.length === 6) {
                      document.getElementsByClassName(
                        "el-upload"
                      )[2].style.display = "none";
                    }
                  } else if (option.filename === "audio") {
                    self.audioFile.push({
                      name: file.name,
                      url: self.$GLOBAL.picFileUrl + val.name
                    }); // 展示图片

                    //cdn预热
                    self.$cdnFun(self.audioFile[0].url).then(res => {});

                    document.getElementsByClassName(
                      "el-upload"
                    )[3].style.display = "none";
                  }
                  return val;
                } else {
                  option.onError("上传失败");
                }
              },
              err => {
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    handchangeVip() {
      this.replyContent = "";
      this.titlePictureUrl = [];
      this.VideoUrl = [];
      this.videoFlag = false;
      this.imgFlag = false;
    },
    // 图片上传之前的回调函数
    // 上传图片之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片只能是jpg或者png格式", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過20MB", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000
              })
              .then(res => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },
    errorVideo(data) {
      this.$propMessage(data, "error");
    },
    // 主图移除图片的回调函数
    handleRemove(file) {
      this.imgFlag = false;
      this.$deleteUidItem(file.uid, this.mainPictureUrl);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
      return false;
    },
    handleVideoExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一個視頻", "error", function() {
        _this.dialogVisible = false;
      });

      return false;
    },
    audiohandleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一條音頻", "error", function() {
        _this.dialogVisible = false;
      });
      return false;
    },
    beforeVideoUpload(file) {
      let _this = this;
      // const isVideo = file.type === 'video/mp4' || 'video/3gp' || 'video/3gpp' || 'video/rm' || 'video/rmvb' || 'video/avi' || 'video/wmv' || 'video/mov';
      const isVideo = file.type === "video/mp4";
      // const isLt200M = file.size / 1024 / 1024 < 2048;
      if (!isVideo) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳視頻格式不正確", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      // if (!isLt200M) {
      //   this.$Mint.Toast('上傳視頻大小不能超過2GB!');
      //   return false;
      // };
    },
    handleVideoRemove(file) {
      this.VideoUrl = [];
      this.videoFlag = false;

      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
      return false;
    },
    // 视频进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    // 主图进度条
    uploadImgProcess(event, file, fileList) {
      this.imgFlag = true;
      this.imgUploadPercent = Number(file.percentage.toFixed(0));
    },
    toReply(e) {
      if (!e.replyId) {
        this.replyId = e.replyId;
        this.id = e.id;
        this.showMoadl = true;
        this.username = e.nickname;
        this.replyContent = "";
        this.letterValue = 1;
        this.titlePictureUrl = [];
        this.VideoUrl = [];
        this.videoFlag = false;
        this.imgFlag = false;
      }
    },
    toDeled: throttle(
      function() {
        return true;
      },
      function(e) {
        let _this = this;
        _this.$message.closeAll();
        const param = {
          id: e.id,
          isValid: 0
        };
        _this
          .$post(`/request/letter/operate`, param, _this.$GLOBAL.jsonConfig)
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.dialogVisible = false;
              if (
                !_this.has_next &&
                _this.userInfoList.length == 1 &&
                _this.currentPage > 1
              ) {
                _this.currentPage--;
              }
              this.$message({
                message: "删除成功",
                type: "success"
              });
              _this.getUserInfoList();
            } else {
              _this.dialogVisible = false;
              _this.$propMessage(res.message, "error");
            }
          });
      },
      2000
    ),

    toSet: throttle(
      function() {
        return true;
      },
      function(e) {
        let _this = this;
        _this.$message.closeAll();
        const choice = e.choice == 1 ? 0 : 1; // 切换精選状态
        const param = {
          id: e.id,
          choice
        };
        _this
          .$post(`/request/letter/operate`, param, _this.$GLOBAL.jsonConfig)
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.dialogVisible = false;
              this.$message({
                message: "設置成功",
                type: "success"
              });
              _this.getUserInfoList();
            } else {
              _this.dialogVisible = false;
              _this.$propMessage(res.message, "error");
            }
          });
      },
      2000
    )
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .tableWrap {
      width: 100%;
      margin-top: 0.4rem;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
.chart_input {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  outline: none;
  padding: 20px;
  resize: none;
  color: #000000;
  font-size: 14px;
}
/deep/ .el-form-item__label {
  width: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/letter/letterList.vue